// extracted by mini-css-extract-plugin
export default {"box":"Box_box__ja5EC","warning":"Box_warning__yz8s6","danger":"Box_danger__IbxtR"};